import module from '@kendu/ui/module'

module.config(($httpProvider) => {
  $httpProvider.interceptors.push('KdHttpInterceptor')
  $httpProvider.defaults.paramSerializer = '$httpParamSerializerJQLike'
})



// WEBPACK FOOTER //
// ./src/kendu/ui/config.js